import { useCallback } from 'react';
import { MenuItem, Select } from '@mui/material';

export default function PSSDIEdit(props) {
  const { id, field, value, api, options } = props;

  const handleChange = useCallback(
    (event) => {
      const eventValue = event.target.value; // The new value entered by the user
      const newValue = typeof eventValue === 'string' ? value : eventValue;

      api.setEditCellValue({ id, field, value: newValue }, event);
    },
    [api, field, id]
  );

  return (
    <Select
      defaultOpen={true}
      multiple
      value={value ? value : []}
      onChange={handleChange}
    >
      {options?.map((option) => (
        <MenuItem key={option} value={option}>
          {option}
        </MenuItem>
      ))}
    </Select>
  );
}
